import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Input, Button, notification } from 'antd';
import { useMutation } from '@apollo/client';
import { updateStrategyGuideMutation } from './constants';

const { TextArea } = Input;

function StrategyGuideNotesModal({
  visible,
  onCancel,
  onComplete,
  strategyGuide,
}) {
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const [updateStrategyGuide] = useMutation(updateStrategyGuideMutation);

  useEffect(() => {
    if (strategyGuide && visible) {
      setNotes(strategyGuide.notes || '');
    }
  }, [strategyGuide, visible]);

  const handleSave = useCallback(async () => {
    try {
      setSaving(true);
      await updateStrategyGuide({
        variables: {
          strategyGuide: {
            _id: strategyGuide._id,
            notes: notes || null,
            notesText: notes ? notes.replace(/<[^>]*>/g, '') : null,
          },
        },
      });

      notification.success({
        message: 'Success',
        description: 'Notes updated successfully.',
      });

      onComplete();
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Error',
        description: 'Failed to update notes.',
      });
    } finally {
      setSaving(false);
    }
  }, [notes, strategyGuide, updateStrategyGuide, onComplete]);

  const handleCancel = useCallback(() => {
    setNotes(strategyGuide?.notes || '');
    onCancel();
  }, [strategyGuide, onCancel]);

  if (!strategyGuide) return null;

  return (
    <Modal
      title={`Edit Notes - Strategy Guide v${strategyGuide.version}`}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} disabled={saving}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave} loading={saving}>
          Save Notes
        </Button>,
      ]}
      width={600}
    >
      <TextArea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={8}
        placeholder="Add notes about this strategy guide..."
      />
    </Modal>
  );
}

export default StrategyGuideNotesModal;
